import ReferencesAPI from 'api/referencesAPI';
import { Reference as ReferenceResponse } from 'types';
import { ReferenceToSubmit } from './types';

export const createReference = (payload: ReferenceToSubmit): Promise<ReferenceResponse> =>
  ReferencesAPI.createReference(payload).then((res) => res);
